export default __webpack_public_path__ + "static/media/p3.12443cc3.jpeg";